import React from "react";
import {
  Box,
  Text,
  FormControl,
  Input,
  InputGroup,
  InputLeftElement,
  Button,
  Spinner,
} from "@chakra-ui/react";
import { EmailIcon } from "@chakra-ui/icons";
const ForgotPasswordStep1 = (props) => {
  const { isLoading, forgotPasswordHandler, email, setEmail } = props;
  return (
    <Box>
      <Text fontSize="xl" mt={6} mb={2}>
        Enter your email below and we will send a message to reset your password
      </Text>
      <form onSubmit={forgotPasswordHandler}>
        <FormControl>
          <InputGroup mt={2} mb={2}>
            <InputLeftElement
              pointerEvents="none"
              children={<EmailIcon />}
              color="gray"
            />
            <Input
              type="email"
              name="email"
              placeholder="Enter Email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
            />
          </InputGroup>
        </FormControl>
        <Button
          mt={2}
          type="submit"
          size="sm"
          colorScheme="blue"
          disabled={isLoading || !email}
        >
          {isLoading ? <Spinner size="sm" mr={2} /> : null}
          Next
        </Button>
      </form>
    </Box>
  );
};

export default ForgotPasswordStep1;
